import { useEffect, useState } from "react";
import { Button, Card, Input, Space } from "antd";

interface CustomerCommentCardProps {
  comment: string | null;
  placeholder: string;
  /** Awaited only — the caller decides what a saved comment means. */
  onSave: (comment: string | null) => Promise<unknown>;
  size?: "default" | "small";
  rows?: number;
}

/**
 * The one comment box customers get, on both delivery flows — the status page and Min side.
 * Saving is the caller's business: a check-in and a mail order reach the same endpoint by
 * different references.
 */
export function CustomerCommentCard({
  comment,
  placeholder,
  onSave,
  size = "default",
  rows = 4,
}: CustomerCommentCardProps) {
  const [draft, setDraft] = useState(comment ?? "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft(comment ?? "");
  }, [comment]);

  const changed = draft.trim() !== (comment ?? "").trim();

  const save = async () => {
    setSaving(true);
    try {
      await onSave(draft.trim() || null);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card size={size} title="Kommentar til David-Andersen">
      <Space direction="vertical" size="small" style={{ display: "flex" }}>
        <Input.TextArea
          rows={rows}
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder={placeholder}
          maxLength={2000}
          showCount
        />
        <Space>
          <Button type="primary" loading={saving} disabled={!changed} onClick={() => void save()}>
            Lagre kommentar
          </Button>
          {changed ? <Button onClick={() => setDraft(comment ?? "")}>Angre</Button> : null}
        </Space>
      </Space>
    </Card>
  );
}
